<template>
  <div class="basic-template">
    <main-menu />
    <div class="basic-template__content pa-2">
      <slot/>
    </div>
  </div>
</template>

<script>
import MainMenu from '../components/MainMenu/MainMenu.vue';

export default {
  name: 'BasicTemplate',
  components: { MainMenu },
};
</script>

<style scoped lang="scss">
.basic-template {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.basic-template__content {
  flex: 1;
  min-width: 0;
}
</style>
